import React from 'react';
import { BsFillArrowLeftCircleFill } from 'react-icons/bs';
import { Database } from '../../server/database';
import { Server } from '../../server/server';
import { getAssetImage, getBannerImage, getPortraitImage } from '../util/util';
import './Modal.css'
import './WelcomeModal.css'

interface WelcomeModalProps {
  open: boolean;
  onClose: Function;
}

interface WelcomeModalState {
  page: number;
  name: string;
  portraits: any[];
  portrait: string;
  banners: any[];
  banner: string;
}

class WelcomeModal extends React.Component<WelcomeModalProps, WelcomeModalState> {
  constructor(props:WelcomeModalProps) {
    super(props);

    this.state = {
      page: 0,
      name: '',
      portraits: this.getRandomPortraits(),
      portrait: '',
      banners: this.getRandomBanners(),
      banner: ''
    }

    this.onNameChange = this.onNameChange.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.onPortraitClick = this.onPortraitClick.bind(this);
    this.onBannerClick = this.onBannerClick.bind(this);
    this.onBack = this.onBack.bind(this);
  }

  onNameChange(e:any) {
    this.setState({name: e.target.value});
  }

  onKeyDown(e:any) {
    if (e.key === 'Enter' && this.state.page == 1)
      this.onContinue();
  }

  getRandomPortraits():any[] {
    let pool = ['portrait-baseball', 'portrait-bat', 'portrait-cat', 'portrait-coffee', 'portrait-cupcake', 'portrait-dice', 
      'portrait-earth', 'portrait-guitar', 'portrait-helicopter', 'portrait-king', 'portrait-moon', 'portrait-pumpkin', 
      'portrait-recycle', 'portrait-sucker', 'portrait-web'];

    let picks = [];
    for(let i = 0; i < 3; i++) {
      let n = Math.floor(Math.random() * pool.length);
      let portrait = Database.getAsset(pool[n]);
      picks.push(portrait);
      pool.splice(n, 1);
    }

    return picks;
  }

  renderPortraits() {
    let images = [];

    for(let i = 0; i < this.state.portraits.length; i++) {
      let portrait = this.state.portraits[i];
      let selected = (portrait.id == this.state.portrait)
      images.push(
        <img key={i} 
          id={portrait.id} 
          className={'welcome-modal-portrait' + (selected ? ' selected' : '')}
          src={getAssetImage(portrait)} 
          onClick={this.onPortraitClick}
        />
      )
    }

    return images;
  }

  onPortraitClick(e:any) {
    this.setState({portrait: e.target.id});
  }

  getRandomBanners():any[] {
    let pool = ['banner-abstract', 'banner-celebrate', 'banner-diamonds', 'banner-purple-green-gradient', 'banner-polygons'];

    let picks = [];
    for(let i = 0; i < 3; i++) {
      let n = Math.floor(Math.random() * pool.length);
      let banner = Database.getAsset(pool[n]);
      picks.push(banner);
      pool.splice(n, 1);
    }

    return picks;
  }

  renderBanners() {
    let banners = [];

    for(let i = 0; i < this.state.banners.length; i++) {
      let banner = this.state.banners[i];
      let selected = (banner.id == this.state.banner)
      banners.push(
        <img key={i} 
          id={banner.id} 
          className={'welcome-modal-banner' + (selected ? ' selected' : '')}
          src={getAssetImage(banner)} 
          onClick={this.onBannerClick}
        />
      )
    }

    return banners;
  }

  onBannerClick(e:any) {
    this.setState({banner: e.target.id});
  }

  onContinue() {
    switch(this.state.page) {
      case 0:
        this.setState({page: 1, name: Server.user.getName()});
        break;
      case 1:
        let portrait = this.state.portrait;
        if(portrait == '')
          portrait = this.state.portraits[0].id;
        this.setState({page: 2, portrait: portrait});
        break;
      case 2:
        let banner = this.state.banner;
        if(banner == '')
          banner = this.state.banners[0].id;
        this.setState({page: 3, banner: banner});
        break;
      case 3:
        this.setState({page: 4});
        this.finish();
        break;
    }
  }

  onBack() {
    let newPage = this.state.page - 1;
    this.setState({page: newPage});
  }

  finish() {
    let name = this.state.name;
    let portrait = this.state.portrait;
    let banner = this.state.banner;

    if(name == '') 
      name = Server.user.getName();

    if(portrait == '') {
      let r = Math.floor(Math.random() * this.state.portraits.length);
      portrait = this.state.portraits[r];
    }

    if(banner == '') {
      let r = Math.floor(Math.random() * this.state.banners.length);
      banner = this.state.banners[r];
    }

    setTimeout(async () => {
      await Server.user.welcome(name, banner, portrait);
      this.props.onClose();
    }, 500);
  }

  renderPage() {
    if(this.state.page == 0) {
      return (
        <div className="welcome-modal-page">
          <div>
            <div className="welcome-modal-page-header">
              Welcome to PlayPlace
            </div>
            <div>
              Thanks for checking out the Alpha version of PlayPlace!  Lets setup your profile to get started.
            </div>
          </div>
          <div>
            <button onClick={()=>this.onContinue()}>Continue</button>
          </div>
        </div>
      )
    }
    else if(this.state.page == 1) {
      return (
        <div className="welcome-modal-page">
          <div>
            <div className="welcome-modal-page-header">
              Profile Name
            </div>
            <div>
              What is your name?
            </div>
          </div>
          <div>
            <input type="text" value={this.state.name} onChange={this.onNameChange}  onKeyDown={this.onKeyDown} placeholder="Enter name"></input>
          </div>
          <div>
            <button onClick={()=>this.onContinue()}>Continue</button>
          </div>
        </div>
      )
    }
    else if(this.state.page == 2) {
      return (
        <div className="welcome-modal-page">
          <div>
            <button className="welcome-modal-back-button" onClick={this.onBack}>
              <BsFillArrowLeftCircleFill />
            </button>
            <div className="welcome-modal-page-header">
              Profile Portrait
            </div>
            <div>
              Choose a portrait for your profile:
            </div>
          </div>
          <div className="welcome-modal-portrait-container">
            {this.renderPortraits()}
          </div>
          <div>
            You can earn new portraits by playing games.
          </div>
          <div>
            <button onClick={()=>this.onContinue()}>Continue</button>
          </div>
        </div>
      )
    }
    else if(this.state.page == 3) {
      return (
        <div className="welcome-modal-page">
          <div>
            <button className="welcome-modal-back-button" onClick={this.onBack}>
              <BsFillArrowLeftCircleFill />
            </button>
            <div className="welcome-modal-page-header">
              Profile Banner
            </div>
            <div>
              Choose a banner for your profile:
            </div>
          </div>
          <div className="welcome-modal-banner-container">
            {this.renderBanners()}
          </div>
          <div>
            You can earn new banners by playing games.
          </div>
          <div>
            <button onClick={()=>this.onContinue()}>Continue</button>
          </div>
        </div>
      )
    }
    else if(this.state.page == 4) {
      return (
        <div className="welcome-modal-page">
          <div>
            Saving profile...
          </div>
        </div>
      )
    }
  }

  render() {
    if(!this.props.open)
      return (null);

    return (
      <div className="modal open">
        <div className="modal-content welcome-modal-content">
          {this.renderPage()}
        </div>
      </div>
    )
  }
}

export default WelcomeModal;